import { useIntlModule } from 'utils/intl/useIntlModule';
import messages from './gender.intl.json';

export function useGenderIntl() {
  return useIntlModule(messages);
}
